<template>
  <!-- 商品类型选择 -->
  <!-- <el-form-item :prop="prop"> -->
  <el-cascader
    :options="options"
    :placeholder="inputPlaceholder || $t('app.pleaseSelectProductType')"
    @change="changeProduct"
    :props="{ checkStrictly: false, multiple: true }"
    clearable
    collapse-tags
    v-model="result"
    ref="cascader"
  ></el-cascader>
  <!-- </el-form-item> -->
</template>

<script>
import { StageOptions } from "@/util/basicJson";
export default {
  data() {
    return {
      options: [],
      result: []
    };
  },
  props: {
    inputPlaceholder: {
      type: String,
      default: ""
    },
    prop: {
      type: String,
      default: ""
    }
  },
  methods: {
    // 切换商品类型
    changeProduct(node) {
      this.result = node; // Directly assign the selected nodes to result
      console.log(this.result);
      this.$emit("changeP", this.result);
    },
    initOptions() {
      let result = StageOptions.map(e => {
        let tempList = e.children.map(e2 => {
          return {
            label: e2.label,
            value: e2.value
          };
        });
        return {
          label: e.label,
          value: e.value,
          children: tempList
        }
      });
      this.options = result;
    },
    resetCascaderInput() {
      this.result = [];
    }
  },
  mounted() {
    this.initOptions();
  }
};
</script>

<style lang="scss" scoped></style>
